var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglereview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feedback"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.3291 6.8223 1.8774-1.83a1 1 0 0 0 -.5542-1.7061l-2.5952-.3769-1.1601-2.3517a1.0418 1.0418 0 0 0 -1.794 0l-1.16 2.3516-2.5952.3769a1 1 0 0 0 -.5542 1.7061l1.8774 1.83-.4434 2.5849a1 1 0 0 0 1.4512 1.0542l2.3212-1.2206 2.3213 1.2207a1 1 0 0 0 1.4512-1.0542z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.9512 6.9229a1.0005 1.0005 0 0 0 -.8076-.6807l-2.5948-.377-1.1611-2.3515a1.041 1.041 0 0 0 -1.7935 0l-1.16 2.3515-2.5947.377a1 1 0 0 0 -.5547 1.7056l1.8779 1.83-.4434 2.585a1 1 0 0 0 1.4507 1.0547l2.3208-1.22 2.3213 1.22a1 1 0 0 0 1.4512-1.0542l-.4433-2.585 1.8775-1.83a1 1 0 0 0 .2537-1.0254z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.1606 6.2422-2.5947-.377-1.16-2.3515a1 1 0 0 0 -1.7935 0l-1.1612 2.3515-2.5948.377a1 1 0 0 0 -.5542 1.706l1.8778 1.8301-.4434 2.585a1 1 0 0 0 1.4512 1.0542l2.3213-1.22 2.3208 1.22a1 1 0 0 0 1.4512-1.0542l-.4434-2.585 1.8779-1.83a1 1 0 0 0 -.5547-1.7056z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 15h-20a3.0033 3.0033 0 0 0 -3 3v8a3.0033 3.0033 0 0 0 3 3h6.5859l2.7071 2.707a.9995.9995 0 0 0 1.414 0l2.7071-2.707h6.5859a3.0033 3.0033 0 0 0 3-3v-8a3.0033 3.0033 0 0 0 -3-3zm-2 10h-16a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2zm0-4h-16a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglereview);
export default __webpack_public_path__ + "static/media/google review.e83f2347ead89ba49c5b8ec188ff35ee.svg";
export { ForwardRef as ReactComponent };